import styled from "styled-components";

export const BackgroundLogoWrapper = styled.div`
  .side-logo {
    position: fixed;
    right: 0;
    top: 0;
  }
`;
